import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

export default class extends Controller {
  static values = { formId: String }

  connect() {
    this.sortable = Sortable.create(this.element, {
      animation: 150,
      dataIdAttr: "data-sortable-id",
      draggable: "[data-sortable-id]",
      handle: "[data-sortable-handle]",
      ghostClass: "opacity-50",
      chosenClass: "bg-primary-50",
      onEnd: (event) => this.handleEnd(event)
    })
  }

  disconnect() {
    this.sortable?.destroy()
  }

  stopPropagation(event) {
    event.stopPropagation()
  }

  moveUp(event) {
    this.move(event.currentTarget, -1)
  }

  moveDown(event) {
    this.move(event.currentTarget, 1)
  }

  handleEnd(event) {
    if (event.oldIndex === event.newIndex) return

    this.submitOrder()
  }

  move(handle, direction) {
    const item = handle.closest("[data-sortable-id]")
    const items = this.items
    const currentIndex = items.indexOf(item)
    const nextIndex = currentIndex + direction

    if (currentIndex < 0 || nextIndex < 0 || nextIndex >= items.length) return

    if (direction < 0) {
      this.element.insertBefore(item, items[nextIndex])
    } else {
      this.element.insertBefore(items[nextIndex], item)
    }

    handle.focus()
    this.submitOrder()
  }

  submitOrder() {
    const form = document.getElementById(this.formIdValue)
    if (!form) return

    form.querySelectorAll("[data-sortable-position]").forEach((input) => input.remove())

    this.items.forEach((item) => {
      const input = document.createElement("input")
      input.type = "hidden"
      input.name = "ids[]"
      input.value = item.dataset.sortableId
      input.dataset.sortablePosition = "true"
      form.appendChild(input)
    })

    form.requestSubmit()
  }

  get items() {
    return Array.from(this.element.children).filter((item) => item.dataset.sortableId)
  }
}
